<template>

<div class="container" >
    <div class="pt-50 columns">        
        <div class="column is-half">
            <div class="card">
                <header class="card-header">
                        <h2 class="is-size-2 card-header-title">
                            Pay 
                            <span class="right">${{amount}} / Month</span>
                        </h2>
                </header>
                <div class="error red center-align white-text">{{stripeValidationError}}</div>
                <div class="card-content">

                    <div class="field">
                        <label class="label">Card Number</label>
                        <div id="card-number-element" class="input-value"></div>
                    </div>

                    <div class="field">
                        <label class="label">Expiry Date</label>
                        <div id="card-expiry-element"></div>
                    </div>

                    <div class="field">
                        <label class="label">CVC</label>
                        <div id="card-cvc-element"></div>
                    </div>
                    <b-field>
                        <button class="button is-fullwidth is-primary" @click="placeOrderButtonPressed">
                            Make Payment
                        </button>
                    </b-field>
                    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
                </div>
            </div>
        </div>
        <div class="column is-half">
         <div class="content is-large">
    <h2>What You Get</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.</p>
    <ul>
      <li>Upload unlimited recipes, meals and menus.</li>
      <li>Save Unlimited recipes, meals and menus.</li>
    </ul>
  </div>
        </div>
    </div>
</div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';
         

export default {
    data() {
        return {
            email: null,
            stripe: null,
            cardNumberElement: null,
            cardExpiryElement: null,
            cardCVCElement: null,
            stripeValidationError: "",
            amount:3,
            isLoading: false,
            isFullPage: true,
            userRef:null
        };
    },
    mounted() {
        this.stripe = window.Stripe("pk_test_AaGtIxmZhPxUdmpCSybbn5ZI");
        
        // get user document of logged in user. Check if customer exists
        this.userRef = db.collection("users").doc(firebase.auth().currentUser.uid);
        this.userRef.get().then(function(doc) {
            if (doc.data().customer) {
                console.log("Document data:", doc.data().customer);
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

        
        this.createAndMountFormElements();
    },
    methods: {
        createAndMountFormElements() {
            var elements = this.stripe.elements();
            this.cardNumberElement = elements.create("cardNumber");
            this.cardNumberElement.mount("#card-number-element");
            this.cardExpiryElement = elements.create("cardExpiry");
            this.cardExpiryElement.mount("#card-expiry-element");
            this.cardCvcElement = elements.create("cardCvc");
            this.cardCvcElement.mount("#card-cvc-element");
            this.cardNumberElement.on("change", this.setValidationError);
            this.cardExpiryElement.on("change", this.setValidationError);
            this.cardCvcElement.on("change", this.setValidationError);
        },
        setValidationError(event) {
            this.stripeValidationError = event.error ? event.error.message : "";
        },
        placeOrderButtonPressed() {
            this.isLoading = true;
            this.stripe.createToken(this.cardNumberElement).then(result => {
                if (result.error) {
                    this.stripeValidationError = result.error.message;
                    this.isLoading = false;
                } else {
                    this.email = firebase.auth().currentUser.email;
                    var stripeObject = {
                        email: this.email,
                        amount: this.amount,
                        user_id: firebase.auth().currentUser.uid,
                        source: result.token
                    };
                    this.saveDataToFireStore(stripeObject);
                }
            });
        },
        saveDataToFireStore(stripeObject) {
            this.isLoading = true;
            // const db = firebase.firestore()
            const chargesRef = db.collection("charges")
            const pushId = chargesRef.doc().id
            db.collection("charges").doc(pushId).set(stripeObject)
            chargesRef.doc(pushId).onSnapshot(snapShot => {
                 const charge = snapShot.data();
                 if (charge.status) {
                     this.isLoading = false;
                     if(charge.status == "succeeded") {
                        console.log(charge);                    
                        this.isLoading = false;
                        alert(charge.status);
                     }
                }
                if (charge.error) {
                    console.log(charge.error);
                    chargesRef
                    .doc(pushId)
                    .delete();
                    this.isLoading = false;
                    return;
                }
                else {
                    console.log(charge);
                    this.isLoading = false;
                }    
            })
        },
        openLoading() {
                this.isLoading = true;
            },
    }
};
</script>
